/** @jsx jsx */
import React, { useState } from 'react';
import { jsx } from 'theme-ui';
import Modal from 'react-modal';
import { FaTimes } from 'react-icons/fa';
import { isBrowser } from '../../helpers/isBrowser';

const AdoptEmbryoButton = ({ style }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  function openModal(content) {
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }
  const [terms, setTerms] = useState(false);

  const continueToApplication = () => {
    if (terms) {
      isBrowser && (window.location.href = 'https://login.embryodonation.org/auth/registration');
    }
  };
  return (
    <>
      <button
        title="Adopt Embryo"
        sx={{
          display: 'block',
          my: '1rem',
          fontSize: '1rem',
          color: ' #FFFFFF !important',
          p: '1rem 1.5rem !important',
          background: ' #F7A496',
          borderRadius: '8px',
          textAlign: 'center',
          minWidth: '175px',
          border: '1px solid #F7A496',
          '&:hover': {
            background: ' transparent',
            color: ' #F7A496 !important',
          },
          ...style,
        }}
        onClick={openModal}
      >
        Adopt Embryos
      </button>
      <div
        sx={{
          display: 'none',
          '.modal-container': {
            display: 'flex',
            flexDirection: 'column',
            header: {
              display: 'flex',
              justifyContent: 'space-between',
              padding: '0 0.5rem',
            },
          },
        }}
      >
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
              zIndex: '99998',
            },
            content: {
              zIndex: '99999',
              top: '55%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              overflowY: 'auto',
              maxHeight: '80vh',
              maxWidth: '1024px',
              // fontFamily: ' Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol,system-ui, -apple-system, BlinkMacSystemFont, Noto Color Emoji',
              padding: '2rem',
            },
          }}
        >
          <header
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              mb: '1rem',
            }}
          >
            IMPORTANT!
            <button onClick={closeModal} sx={{}}>
              <FaTimes />
            </button>
          </header>
          <div sx={{ p: { my: '1rem' } }}>
            <p>
              {' '}
              <strong>
                WELCOME! You are about to fill out the formal NEDC application to adopt embryos. (If
                you are not yet ready to adopt embryos but would like to learn more, please visit
                the Adoption section of our website.) You will be asked to pay a <i>non-refundable</i> $515 application
                fee when submitting your application. Program requirements are below:{' '}
              </strong>
            </p>
            <ul>
              <li>
                {' '}
                Couples must be a genetic male and a genetic female married for a minimum of 3
                years.
              </li>
              <li>Wife must be 45 years old or younger.</li>
              <li>
                {' '}
                Wife’s body mass index (BMI) must be below 38 at the time of the frozen embryo
                transfer.{' '}
              </li>
              <li> The combined age of the applicant couple must not exceed 100 years.</li>
              <li>
                {' '}
                The adopting mother must be healthy and able to carry a child to term. Surrogates
                are not an option for carrying the pregnancy.{' '}
              </li>
              <li>
                {' '}
                The wife must not smoke during the application process, embryo transfer preparation
                and procedure process, or during pregnancy.
              </li>
              <li>
                {' '}
                Both husband and wife must be free of alcohol dependence and other substance
                dependence for two years before adopting. A letter from an addiction specialist may
                be required.
              </li>
              <li>
                {' '}
                All couples must complete and pass a 10-panel urine drug screen as well as a blood
                test for sexually transmitted diseases.{' '}
              </li>
              <li>
                Couples must complete and pass a comprehensive family assessment (home study)
                prepared by a licensed adoption agency in the couple’s state, territory or province
                of residency, or an embryo adoption-specific Snowflakes Family Evaluation in lieu of
                a home study.
              </li>
            </ul>
            <p>
              {' '}
              <strong>
                We are not able to make any exceptions to these requirements. If you meet the
                requirements, our dedicated staff will help prepare you every step of the way for
                the exciting journey ahead.
              </strong>
            </p>
          </div>
          <label htmlFor="terms" sx={{ display: 'block', mt: '1rem', textAlign: 'center' }}>
            {' '}
            <input
              type="checkbox"
              name="terms"
              id="terms"
              value={terms}
              onChange={(e) => setTerms(e.target.checked)}
            />{' '}
            I have read and meet the program requirements
          </label>
          <div
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '1rem',
              flexWrap: 'wrap',
              justifyContent: 'center',
              my: '1rem',
              button: {
                display: 'block',
                fontSize: '1.25rem',
                fontWeight: 600,
                color: ' #FFFFFF !important',
                p: '1rem 1.5rem !important',
                background: ' #F7A496',
                borderRadius: '8px',
                textAlign: 'center',
                minWidth: '175px',
                border: '1px solid #F7A496',
                transition: 'all 0.35s',
                '&:hover:not(:disabled)': {
                  background: ' transparent',
                  color: ' #F7A496 !important',
                },
              },
              'button:disabled': {
                opacity: '0.5',
                cursor: 'not-allowed',
              },
            }}
          >
            <button disabled={!terms} onClick={continueToApplication}>
              Continue to the Application
            </button>
            <p>
              Already have an account?{' '}
              <a href="https://login.embryodonation.org/auth/login">Login</a>
            </p>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default AdoptEmbryoButton;
